import * as number from './filters.number';
export {
  number
};
